import rest from 'redux/rest'

/**
 * Fetches brands list by gender
 *
 * @returns {Promise} request
 */
const fetch = (gender) =>
  rest.models.brands.fetch({
    query: {
      gender,
    },
  })
    .then(({ brands: items }) => items)


export default {
  fetch,
}
